module.exports = __webpack_public_path__ + "img/pd-img14.6307f792.png";